export default "__VITE_ASSET__Fi6jA3T___"